import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import Layout from "../../../components/Layouts/Layouts/Layout";
import MasterNavigationBar from "../../../components/Layouts/Layouts/MasterServicesLayout";
import { getAuthUserCookie } from "../../../store/services";
import { getURLbyEndPoint } from "../../../store/api";
import axios from "axios";
import { useEffect, useState } from "react";

const MasterEvent = () => {
  const navigate = useNavigate();
  const [notificationData, setNotificationData] = useState([]);

  //notification values
  const fetchNotification = async () => {
    try {
      const response = await axios.get(
        getURLbyEndPoint("getNotificationStatus"),
      );
      console.log(response);
      if (response.status === 200) {
        const data = response.data.data;
        setNotificationData(data);
      } else {
        alert("Failed to fetch notification data.");
      }
    } catch (error) {
      alert("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchNotification();
  }, []);

  return (
    <Layout>
      <MasterNavigationBar>
        <div className="d-flex flex-column px-3">
          <DashboardHeader heading="EVENTS" backUrl="/master-dashboard" />

          <hr />
          <div className="d-flex justify-content-around mb-2">
            <button
              onClick={() => {
                navigate("/chamber-event");
              }}
              disabled={
                !getAuthUserCookie().accessList.includes("ChamberBookingEvent")
              }
              type="button"
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1 position-relative d-inline-flex align-items-center justify-content-center"
              style={{ width: "35%" }}
            >
              <div className="gap-2 d-flex justify-content-center align-items-center">
                <span>CHAMBER EVENTS BOOKING</span>
              </div>
              <span
                className="badge bg-primary position-absolute fs-6"
                style={{ top: "-8px", right: "-8px" }}
              >
                {notificationData.chamberBooking !== 0
                  ? notificationData.chamberBooking
                  : null}
              </span>
            </button>
            <button
              type="button"
              onClick={() => {
                navigate("/b2b-virtual-forum");
              }}
              // disabled={!getAuthUserCookie().accessList.includes("B2BEvents")}
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1 position-relative d-inline-flex align-items-center justify-content-center"
              style={{ width: "35%" }}
            >
              B2B VIRTUAL FORUM{" "}
              <span
                className="badge bg-primary position-absolute fs-6"
                style={{ top: "-8px", right: "-8px" }}
              >
                {notificationData.collaboratorBooking !== 0
                  ? notificationData.collaboratorBooking
                  : null}
              </span>
            </button>
          </div>
          <hr />
          <div className="d-flex justify-content-around mb-2">
            <button
              onClick={() => {
                navigate("/cloud-meetings");
              }}
              type="button"
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1"
              style={{ width: "35%" }}
            >
              <div className="gap-2 d-flex justify-content-center align-items-center">
                <span>CLOUD MEETINGS</span>
              </div>
            </button>
            <button
              type="button"
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1"
              style={{ width: "35%" }}
              disabled={
                !getAuthUserCookie().accessList.includes("SponsorShips")
              }
            >
              <div className="gap-2 d-flex justify-content-center align-items-center">
                <span>SPONSORSHIP</span>
              </div>
            </button>
          </div>
          <hr />
        </div>
      </MasterNavigationBar>
    </Layout>
  );
};

export default MasterEvent;
